import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {catchError} from 'rxjs/operators';
import {HandleErrorService} from '../handleError.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataPilotInfoService extends HandleErrorService {

  getAll() {
    const apiConcession = environment.ispaccUrlDomaine + '/api/pilot-info/get-all';
    return this.http.get<any>(apiConcession, environment.httpOptionSimple).pipe(
      catchError(this.handleError)
    );
  }

  getById(id) {
    const apiConcession = environment.ispaccUrlDomaine + '/api/pilot-info/get/' + id;
    return this.http.get<any>(apiConcession, environment.httpOptionSimple).pipe(
      catchError(this.handleError)
    );
  }

  createContent(body) {
    const apiConcession = environment.ispaccUrlDomaine + '/api/pilot-info/create';
    return this.http.post<any>(apiConcession, body, environment.httpOptionSimple).pipe(
      catchError(this.handleError)
    );
  }

  updateContent(body, id) {
    const apiConcession = environment.ispaccUrlDomaine + '/api/pilot-info/update/' + id;
    return this.http.post<any>(apiConcession, body, environment.httpOptionSimple).pipe(
      catchError(this.handleError)
    );
  }

  stopContent(id) {
    const apiConcession = environment.ispaccUrlDomaine + '/api/pilot-info/stop-content/' + id;
    return this.http.get<any>(apiConcession, environment.httpOptionSimple).pipe(
      catchError(this.handleError)
    );
  }
  requestGetImage(concessionId, contentId): Observable<any> {
    return this.http.get<any>(environment.ispaccUrlDomaine + '/api/pilot-info/get-image/' + concessionId + '/' + contentId, environment.httpOptionSimple).pipe(
      catchError(this.handleError)
    );
  }
  requestUploadImage(data): Observable<any> {
    return this.http.post<any>(environment.ispaccUrlDomaine + '/api/pilot-info/upload-image', data, environment.httpOptionSimple).pipe(
      catchError(this.handleError)
    );
  }
  requestDeleteImage(concessionId, contentId): Observable<any> {
    return this.http.delete<any>(environment.ispaccUrlDomaine + '/api/pilot-info/delete-image/' + concessionId + '/' + contentId, environment.httpOptionSimple).pipe(
      catchError(this.handleError)
    );
  }
}
